import React from 'react'
import { Alert as IAlert } from './types'
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaExclamationCircle,
  FaInfoCircle,
} from 'react-icons/fa'
import {
  Alert as ChakraAlert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  CloseButton,
  AlertStatus,
  Stack,
} from '@chakra-ui/react'

const alertStyles = {
  success: {
    borderTopColor: '#53A33B',
    bg: '#C6F6D5',
  },
  warning: {
    borderTopColor: '#F58D26',
    bg: '#FEFCBF',
  },
  error: {
    borderTopColor: '#EE473E',
    bg: '#FED7D7',
  },
  info: {
    borderTopColor: 'blue.500',
    bg: '#BEE3F8',
  },
}

const getAlertIcon = (status: AlertStatus) => {
  switch (status) {
    case 'error':
      return FaExclamationTriangle
    case 'success':
      return FaCheckCircle
    case 'warning':
      return FaExclamationCircle
    case 'info':
      return FaInfoCircle
    default:
      return FaExclamationCircle
  }
}

const Alert = ({
  status = 'error',
  variant = 'top-accent',
  title,
  description,
  isClosable = false,
  dismiss,
  direction = 'row',
  showIcon = true,
  ...restProps
}: IAlert) => {
  return (
    <ChakraAlert
      status={status}
      variant={variant}
      {...alertStyles[status]}
      {...restProps}
    >
      {showIcon && <AlertIcon as={getAlertIcon(status)} mb="auto" />}
      <Stack direction={direction} spacing={0}>
        {title && <AlertTitle mr={2}>{title}</AlertTitle>}
        {description && <AlertDescription>{description}</AlertDescription>}
      </Stack>
      {isClosable && (
        <CloseButton
          position="absolute"
          right="8px"
          top="3px"
          onClick={dismiss}
        />
      )}
    </ChakraAlert>
  )
}

export default Alert
